import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DialogService } from 'src/app/services/dialogService/dialog-service';
import { SubscriberService } from 'src/app/services/subscriberService/subscriber.service';

@Component({
  selector: 'app-tv-login',
  templateUrl: './tv-login.component.html',
  styleUrls: ['./tv-login.component.less']
})
export class TvLoginComponent {
  loginTvGroup: FormGroup;

  constructor(private formBuilder: FormBuilder, private subscriberService: SubscriberService, private dialogService: DialogService) {
    this.loginTvGroup = this.formBuilder.group({
      tvCode: ['', Validators.required]
    });
  }

  tvCodelogin() {
    this.subscriberService.loginCodeTv(this.loginTvGroup.controls.tvCode.value).then((resp: any) => {
      this.dialogService.openConfirmDialog({
        title: "gen_tv_login",
        message: "info_operation_success",
        confirm: "gen_ok"
      }).subscribe(result => { });
    });
  }
}